import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './Loader.css';
import loaderSvg from './loader.svg';

class Loader extends Component {
  static propTypes = {
    show: PropTypes.bool,
  };

  render() {
    if (this.props.show) {
      return (
        <div className="loader-container">
          <img src={loaderSvg} alt="loader" />
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect((state) => {
  return {
    show: state.loader.loading,
  };
}, null)(Loader);



// WEBPACK FOOTER //
// ./src/components/shared/loader/Loader.js